import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import ConfigurationSummary from './config-summary';
import SaveConfigTN from './save-configTN';
import SetupComplete from './setup-complete';

function SaveConfiguration(x) {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <SaveConfigTN />},
    {id: 2, name: 'No', component: <SetupComplete />},
  ];
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress || isKeypressDisabled) return;

  //   onComponent(<ConfigurationSummary />);
  // }, [leftPress]);

  // useEffect(() => {
  //   if (!initiallyDisableKeypress) return;

  //   setTimeout(() => {
  //     setIsKeypressDisabled(false);
  //   }, 500);
  // }, []);

  return (
    <SubMenuView
      title="Save Configuration"
      menuItems={yesNoItem}
      content="Do you want to save these settings as a named configuration?"
      isMenuDisabled
      onLeftCallback={() => onComponent(<ConfigurationSummary />)}
    />
  );
}
export default SaveConfiguration;
